// Utils
import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { ICreateSalesLeadResponse } from "@/DataPages/context/crm/interfaces";
import { TCreateSalesLeadInput } from "@/DataPages/components/CRM/SalesLeads/types/salesLeads";

type TCreateSalesLeadParams = {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	input: TCreateSalesLeadInput;
};

export async function createSalesLead(params: TCreateSalesLeadParams) {
	const { locationId, commissionCycleId, payPeriodId, input } = params;

	const query = gql`
		mutation CreateSalesLead($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $input: CreateSalesLeadInput!) {
			createSalesLead(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, input: $input) {
				locationId
				commissionCycleId
				payPeriodId
				prospect {
					error
					prospectId
				}
			}
		}
	`;

	const variables = {
		commissionCycleId,
		locationId,
		payPeriodId,
		input,
	};

	try {
		const response: GraphqlQueryResponse<"createSalesLead", ICreateSalesLeadResponse> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.createSalesLead;
	} catch (err) {
		errorLogger(err as Error, { function: "createSalesLead", message: "Failed to create sales lead", variables });
		return null;
	}
}
